export function saveData({page, header, contentPage, authorsData} = {}) {

  const arr = [{name: 'Главная', href: '/'}]

  if (contentPage) {
    const {data: {content}} = contentPage
    const category = content.headings[0]
    const prevPage = {name: category?.title, href: category?.href}
    const currentPage = {name: content?.title, href: content?.href}
    arr.push(prevPage)
    arr.push(currentPage)
  }
  if (page) {
    const currentHead = header.headings.find(({href}) => href.slice(1) === page);
    if (!currentHead) return;
    const name = currentHead.title;
    const href = currentHead.href;
    arr.push({name, href})
  }
  if (authorsData) {
    console.log(authorsData, "DATA-BREAD")
    const {info: {author}} = authorsData
    const currentPage = {name: author['first_name'] + " " + author['last_name'], href: ''}
    if (global.breadcrumbs) {
      arr.push(...global.breadcrumbs.slice(1), currentPage)
    } else {
      arr.push(currentPage)
    }
  } else if (global.window) {
    global.breadcrumbs = arr;
  }


  return arr;
}
